import { api } from '@/plugins/axios'

const API_BASE_V1 = process.env.VUE_APP_API_BASE_V1
const BATCH_UPGRADATION_BASE = `${API_BASE_V1}/batch-upgradation`

/**
 * Step 1: Store batch history
 */
const storeBatchHistory = async (institutionId, batchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step1/store-batch-history`, null, { params: { institutionId, batchId } })

  return res
}

/**
 * Step 2: Add new classes for batch
 */
const addNewClassesForBatch = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step2/add-classes`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Step 3: Store last year basic info
 */
const storeLastYearBasicInfo = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step3/store-basic-info`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Step 4: Change basic info to new batch
 */
const changeBasicInfoToNewBatch = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step4/change-basic-info`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Step 5: Copy class fees to new batch
 */
const copyClassFeesToNewBatch = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step5/copy-class-fees`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Step 6: Create batch fees for old students
 */
const createBatchFeesForOldStudents = async (institutionId, newBatchId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/step6/create-batch-fees`, null, { params: { institutionId, newBatchId } })

  return res
}

/**
 * Get upgradation status
 */
const getUpgradationStatus = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.get(`${BATCH_UPGRADATION_BASE}/status`, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Create fees for a specific student
 */
const createBatchFeesForStudent = async (institutionId, newBatchId, studentId) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/student/fees/create`, null, { params: { institutionId, newBatchId, studentId } })

  return res
}

/**
 * Create fees for a specific class-section
 */
const createBatchFeesForClass = async (institutionId, newBatchId, classId, section) => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/class/fees/create`, null, { params: { institutionId, newBatchId, classId, section } })

  return res
}

/**
 * Update fees for a specific student
 */
const updateBatchFeesForStudent = async (institutionId, newBatchId, studentId) => {
  const res = await api.put(`${BATCH_UPGRADATION_BASE}/student/fees/update`, null, { params: { institutionId, newBatchId, studentId } })

  return res
}

/**
 * Update fees for a specific class-section
 */
const updateBatchFeesForClass = async (institutionId, newBatchId, classId, section) => {
  const res = await api.put(`${BATCH_UPGRADATION_BASE}/class/fees/update`, null, { params: { institutionId, newBatchId, classId, section } })

  return res
}

/**
 * Complete batch upgradation wizard
 */
const completeBatchUpgradation = async request => {
  const res = await api.post(`${BATCH_UPGRADATION_BASE}/complete`, request)

  return res
}

export const batchUpgradationApi = {
  storeBatchHistory,
  addNewClassesForBatch,
  storeLastYearBasicInfo,
  changeBasicInfoToNewBatch,
  copyClassFeesToNewBatch,
  createBatchFeesForOldStudents,
  getUpgradationStatus,
  createBatchFeesForStudent,
  createBatchFeesForClass,
  updateBatchFeesForStudent,
  updateBatchFeesForClass,
  completeBatchUpgradation,
}
